import "./index.css";
import axios from "axios";
import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import Auth from "./services/Auth";

axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;

axios.interceptors.request.use(
  async (request) => {
    if (Auth.isAuthenticated) {
      const accessToken = await Auth.getAccessToken();
      request.headers["Authorization"] = "Bearer " + accessToken;
    }
    return request;
  },
  (error) => {
    console.error(error);
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.reload();
    }

    return Promise.reject(error);
  },
);

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount("#app");
